import ChoiceExerciseAnswer from './ChoiceExerciseAnswer.vue';
import ChartExerciseAnswer from './ChartExerciseAnswer.vue';
import OrderTicketAnswer from './OrderTicketAnswer.vue';

const CHOICE_FIELD = {
  choice: 'option',
  entry_choice: 'result_type',
  engulfing_classification: 'result'
};

export function rendererForKind(kind) {
  if (kind === 'order_ticket') return OrderTicketAnswer;
  if (Object.prototype.hasOwnProperty.call(CHOICE_FIELD, kind)) return ChoiceExerciseAnswer;
  return ChartExerciseAnswer;
}

export function rendererProps(item) {
  if (Object.prototype.hasOwnProperty.call(CHOICE_FIELD, item.kind)) {
    return { options: item.question.options, answerField: CHOICE_FIELD[item.kind] };
  }
  return { question: item.question, kind: item.kind };
}
